import type { DatePreset, DateRange, ComparisonType } from '../types'

export const SALES_DASHBOARD_ENDPOINTS = {
  DAILY: '/api/sales-dashboard',
  COMPARE: '/api/sales-dashboard/compare',
  TARGET_PROGRESS: '/api/sales-dashboard/target-progress',
  TARGETS: '/api/monthly-targets',
} as const

export const DEFAULT_DATE_PRESET: DatePreset = 'this_month'

export const DEFAULT_DATE_RANGE: DateRange = {
  preset: 'last_week',
  from: null,
  to: null,
}

export const DEFAULT_COMPARISON_TYPE: ComparisonType = 'wow'

export const COMPARISON_TYPE_OPTIONS: Array<{ value: ComparisonType; labelKey: string }> = [
  { value: 'dod', labelKey: 'salesDashboard.comparison.dod' },
  { value: 'wow', labelKey: 'salesDashboard.comparison.wow' },
  { value: 'mom', labelKey: 'salesDashboard.comparison.mom' },
]

export const BREAKDOWN_OPTIONS: Array<{ value: string; labelKey: string }> = [
  { value: 'factory', labelKey: 'salesDashboard.breakdown.factory' },
  { value: 'customer', labelKey: 'salesDashboard.breakdown.customer' },
  { value: 'city', labelKey: 'salesDashboard.breakdown.city' },
  { value: 'variant', labelKey: 'salesDashboard.breakdown.variant' },
]

export const DATE_PRESETS: Record<DatePreset, { labelKey: string }> = {
  today: { labelKey: 'salesDashboard.dateRange.today' },
  yesterday: { labelKey: 'salesDashboard.dateRange.yesterday' },
  this_week: { labelKey: 'salesDashboard.dateRange.thisWeek' },
  last_week: { labelKey: 'salesDashboard.dateRange.lastWeek' },
  this_month: { labelKey: 'salesDashboard.dateRange.thisMonth' },
  last_month: { labelKey: 'salesDashboard.dateRange.lastMonth' },
  this_quarter: { labelKey: 'salesDashboard.dateRange.thisQuarter' },
  this_year: { labelKey: 'salesDashboard.dateRange.thisYear' },
  last_30_days: { labelKey: 'salesDashboard.dateRange.last30Days' },
  custom: { labelKey: 'salesDashboard.dateRange.custom' },
}

export * from './sub-customer-dashboard'
